export default {
  pupularService: 'Popular on ServisHero',
  newsAndUpdates: 'Latest Updates',
  servisheroApp: 'ServisHero Mobile App',
  downloadSHApp: 'Download the ServisHero app to view job history, manage jobs, and more.'
}